import React from 'react'
import { Subscriber } from 'react-broadcast'

const CurrentUser = ({ render }) => (
  <Subscriber channel="currentUser">{render}</Subscriber>
)

export default CurrentUser



// WEBPACK FOOTER //
// ./src/components/CurrentUser/index.js